<template>
  <div
    class="bg-gray-200 border-gray-300 border font-opensans rounded-md py-2 px-2 pr-6"
  >
    <p class="font-semibold m-2">Nieuwe opmerking</p>
    <a name="comment"></a>
    <div class="ml-2">
      <FeedbackForm :objectid="objectid" mode="add" />
    </div>
  </div>
</template>

<script>
import FeedbackForm from "./FeedbackForm";
export default {
  name: "FeedbackFormCard",
  props: ["objectid"],
  components: {
    FeedbackForm
  }
};
</script>
